"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var ProviderCard_1 = __importDefault(require("../../ProviderCard"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var Slide = function (_a) {
    var providers = _a.providers;
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container }, providers === null || providers === void 0 ? void 0 :
        providers.map(function (item, idx) { return (react_1.default.createElement(ProviderCard_1.default, __assign({ key: "gamesSetCollections".concat(idx) }, item))); }),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.gradient })));
};
exports.default = Slide;
